export interface ErrorResponseData {
  detail: string;
  status: number;
  title: string;
  type: string;
}

export class Status {
  //#region WH
  getWarehouseLoading: boolean = false;
  warehouseErrorMsg: string = '';
  //#endregion
}
